import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";
import back from "../../back.png";
import InputText from "../../helpers/InputText";
import FormatDecimal from "../../helpers/FormatDecimal";
import AppContext from "../../AppContext";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputInteger from "../../helpers/InputInteger";


function PrefixForm(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [priceGroup, setPriceGroup] = useState(null);

    const [errTab, setErrTab] = useState([]); 
    const [row, setRow] = useState({

        id: -1,

        prefix: '0',
        opis1: '',
        opis2: '',
        taryfikacja: '1',
        typ: 'PSTN',

        id_grupy_cennikowej: '_x_',
 

    });
    var tmpRow = row;



    const valChangeListener = (filedName, val, correct, msg) => {   
        
              
        
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];
                    if(correct)tRef[tabInx] = val;
                    if(!correct)tRef[tabInx] = "";

                    tmpRow[tabName] = tRef;     
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                   // if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         


               

                setRow(  JSON.parse(JSON.stringify(tmpRow)) );                               
            }   
        
        
    const goNextNew = () => {
                console.log("goNext");               
            }



   const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    
    const saveData = () => {
        

        if(!valChecker(row))
        {
               
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza  " ,  "error"  ,null); 
                return;
        }

        props.mainView.showProgress();
 

        fetch( Config.url + '/rest_v1_info,prefix_set', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                props.onSuccess(res.result);  //przekaz id Firmy 
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


    const getPrefixDet = () => {
        
    
         props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_info,prefix_det', {
            method: 'POST', 
            body: JSON.stringify( { id: props.id}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


       const getPriceGroup = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_info,price_group_combo', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setPriceGroup(res.result);             
                                    
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }




    
   const keyListener = (e) => {

                        var code = e.keyCode ? e.keyCode : e.which;    
                        console.log("keylockd", e.target.nodeName, code );

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                        }else 
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {                                                           
                        }else  
                        if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                        {
                                props.onBack();                               
                        } else 
                        if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       saveData();                          
                                       e.preventDefault();
                        } else 
                        {
                            props.keyListener(e);
                        }

     }


      useEffect(() => {
         
                if(Config.env == "dev") console.log("PriceForm.js, listener on");
                window.onkeydown =  keyListener;

                return () => {          
                    if(Config.env == "dev") console.log("PriceForm.js, listener off");      
                    window.onkeydown =  props.keyListener;
                };

      });
   





    if(priceGroup == null )
    {
        setPriceGroup([]);
        getPriceGroup();
        return <div>...</div>
    }

    if(row.id < 0 && props.id > 0)
    {
        getPrefixDet();
    }


 


    
    return <div className="view_content">
                  
                       <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                       <div className="app_header">Prefix: {row.prefix}, {row.opis1}, {row.opis2} </div>

                         <form className="eForm bg_center">

                                <div className="form_tab_title">Informacje szczegółowe:</div>

                                 <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Prefix</div>
                                                <InputInteger  userData={props.userData} value={row.prefix} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="prefix" placeholder={"Prefix:"} className='  ' req='0' firstUp="1" />
                                            </div>
                                            
                                      
                                            <div className="form_control">
                                                <div className="fieldName">Opis</div>
                                                <InputText   userData={props.userData} value={row.opis1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis1" placeholder={"Opis:"} className=' w200  ' req='0' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Opis cd.</div>
                                                <InputText   userData={props.userData} value={row.opis2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis2" placeholder={"Opis:"} className=' w200  ' req='0' firstUp="1" />
                                            </div>

                                              <div className="form_control">
                                                <div className="fieldName">Taryfikacja</div>
                                                <InputDecimal   userData={props.userData} value={row.taryfikacja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="taryfikacja" placeholder={"Taryfikacja:"} className=' w50  ' req='0' firstUp="1" />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Typ połączenia*</div>
                                                <InputCombo items={ [  {v:'PSTN',title:'Stacjonarne'},   {v:'GSM',title:'Komórkowe'},     ] }   userData={props.userData} value={row.typ} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ" placeholder={":"} className='  ' req='1' firstUp="1" />
                                            </div>
                                            
                                            <div className="form_control">
                                                <div className="fieldName">Grupa cennikowa*</div>
                                                <InputCombo items={ priceGroup }   userData={props.userData} value={row.id_grupy_cennikowej} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="id_grupy_cennikowej" placeholder={":"} className='  ' req='1' firstUp="1" />
                                            </div>


                                </div>


                                <div className="form_split"></div>

                                <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz [ctrl + s ]</div>
                                        &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                </div>

                         </form>

    </div>


}


export default PrefixForm;